export const GRAMMAR_ITEM_POOLS = ['lesson', 'exam'] as const;
